import { NEXT_PUBLIC_AUTH_SERVICE } from "@/libs/constants/auth";
import { fetchUtil } from "@/libs/fetch";

export const fetchAuthTokenAPI = async (): Promise<any> => {
  return await fetchUtil({
    url: `${NEXT_PUBLIC_AUTH_SERVICE}/fetchAuthToken`,
    method: "GET",
    useToken: true,
    credentials: "include",
    body: {},
    ctype: "",
  });
};
